export interface CachedSipCreds {
  password: string
  sipUsername: string
  sipDomain: string
  sipUri?: string
}

const sipCredentialCache = new Map<string, Promise<CachedSipCreds>>()

export function getOrCreateSipCredential(
  key: string,
  fetcher: () => Promise<CachedSipCreds>,
): Promise<CachedSipCreds> {
  if (!sipCredentialCache.has(key)) {
    const promise = fetcher().catch((err) => {
      sipCredentialCache.delete(key)
      throw err
    })
    sipCredentialCache.set(key, promise)
  }
  return sipCredentialCache.get(key)!
}

export function clearSipCredentialCache(): void {
  sipCredentialCache.clear()
}
